import React from 'react'
import { Route, Routes } from 'react-router-dom'
import HomePage from '../customer/Pages/HomePage/HomePage'
import Navigation from '../customer/components/Navigation/Navigation'
import Footer from '../customer/components/Footer/Footer'
import Cart from '../customer/components/Cart/Cart'
import Product from '../customer/components/Product/Product'
import ProductDetails from '../customer/components/ProductDetails/ProductDetails'
import Checkout from '../customer/components/Checkout/Checkout'
import Order from '../customer/components/Order/Order'
import OrderDetails from '../customer/components/Order/OrderDetails'
import AuthForm from '../customer/Auth/AuthForm'
import PasswordChange from '../customer/components/Usermanagment/PasswordChange'
import OTPInput from '../customer/components/Usermanagment/OTPInput'
import Recovered from '../customer/components/Usermanagment/Recovered'
import OrderClose from '../customer/components/Checkout/OrderClose'
const CustomerRouters = () => {
  return (
    <div>
      <div>
        <Navigation/>
      </div>
      <Routes>
            <Route path='/' element={<HomePage/>}></Route>
            <Route path='/login' element={<HomePage/>}></Route>
            <Route path='/register' element={<HomePage/>}></Route>
            <Route path='/VrfyForm' element={<HomePage/>}></Route>
            <Route path='/auth' element={<AuthForm/>}></Route>
            <Route path='/cart' element={<Cart/>}></Route>
            <Route path='/otpinput' element={<OTPInput/>}></Route>
            <Route path='/password' element={<PasswordChange/>}></Route>
            <Route path='/reseted' element={<Recovered/>}></Route>
            <Route path='/:lavelOne/:lavelTwo/:lavelThree' element={<Product/>}></Route>
            <Route path='/:product/:productId' element={<ProductDetails/>}></Route>
            <Route path='/checkout' element={<Checkout/>}></Route>
            <Route path='/account/order' element={<Order/>}></Route>
            <Route path='/account/order/:orderId' element={<OrderDetails/>}></Route>
      </Routes>
      <div>
        <Footer/>
      </div>
    </div>
  )
}

export default CustomerRouters
